import { ICostSummaryItem, ILineItem } from '../../CartContext.types';

export const useTradeInHook = (
    lineItem: ILineItem,
    frequency: 'monthly' | 'dueToday'
): ICostSummaryItem | undefined => {
    if (lineItem.device?.tradeIn?.price ?? 0 > 0) {
        const item: ICostSummaryItem = {
            lineNumber: lineItem.lineNumber,
            itemName: `Trade In`,
            amount: 0,
            type: 'discount'
        };

        if (frequency === 'monthly') {
            item.amount = lineItem.device?.tradeIn?.pricePerMonth ?? 0;
        } else {
            item.amount = lineItem.device?.tradeIn?.price ?? 0;
        }

        return item;
    }
};
